import { useState } from "react";
import FormSection from "../../../components/FormSection";
import { Select, Form, FormInstance } from "antd";
import Venues from "./Venues";
import Tickets from "./Tickets";

const DiscountAppliedOn = ({ form }: { form: FormInstance }) => {
  const [appliedOn, setAppliedOn] = useState("ticket");
  return (
    <FormSection
      withoutCard={true}
      title="Coupon Application"
      description="Choose where the coupon applies and select relevant tickets or venues."
      dividerEnd
    >
      <>
        <Form.Item
          label="Coupon applied on"
          name={"condition_type"}
          initialValue={"ticket"}
          rules={[
            {
              required: true,
              message: "This field is required",
            },
          ]}
        >
          <Select
            onChange={(e) => {
              setAppliedOn(e);
              form.setFieldsValue({
                condition_values: [],
                selected_event: "",
              });
            }}
            options={[
              { label: "Tickets", value: "ticket" },
              { label: "Events", value: "event" },
            ]}
          />
        </Form.Item>
        {appliedOn === "ticket" ? (
          <Tickets name="condition_values" label="Select tickets" form={form} />
        ) : (
          <Venues />
        )}
      </>
    </FormSection>
  );
};

export default DiscountAppliedOn;
